import { useCallback, useEffect, useState } from 'react';

import { get } from 'ravenjs/utils/lodash';

export function useCompanyConfigurations({
    open,
    companyId,
    fetchConfigurations,
    params: defaultParams,
}) {
    const [data, setData] = useState({ configurations: [], totalRecords: 0 });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchConfigurationsData = useCallback(
        async (
            params = {
                ...defaultParams,
            }
        ) => {
            try {
                setLoading(true);
                const newParams = {
                    ...params,
                    companyId,
                };
                const configurationsResponse = await fetchConfigurations(newParams);

                const configurations = get(configurationsResponse, 'configurations', []);
                const totalRecords = Number(get(configurationsResponse, 'totalRecords', '10'));

                setData({ configurations, totalRecords });
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        },
        [companyId, defaultParams, fetchConfigurations]
    );

    useEffect(() => {
        if (open) {
            fetchConfigurationsData();
        }
    }, [companyId, fetchConfigurationsData, open]);

    const refetchData = useCallback(
        params => {
            const { order, orderBy, page, rowsPerPage, searchSpec } = params;
            const updatedParams = {
                limit: rowsPerPage,
                offset: rowsPerPage * (page - 1),
                searchSpec,
                sort: `${order === 'asc' ? '+' : '-'}${orderBy}`,
            };
            fetchConfigurationsData(updatedParams);
        },
        [fetchConfigurationsData]
    );

    return {
        configurations: data.configurations,
        totalRecords: data.totalRecords,
        error,
        loading,
        refetchData,
    };
}
